"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var useCategories = function useCategories() {
  return (0, _react.useMemo)(function () {
    return [{
      id: 'statement',
      pageId: 'MASSPAYMENTS',
      title: 'Statement',
      url: '/finance/statement'
    }, {
      id: 'spend',
      pageId: 'SPENDREPORTS',
      title: 'Spend',
      url: '/finance/spend-reports'
    }];
  }, []);
};
var _default = useCategories;
exports.default = _default;